import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useAuth } from "hooks/use-auth"
import { useEffect } from "react"
import { PageLoader } from "@/components/page-loader"
import { useUserType } from "@/hooks/use-user-type"

export const Route = createFileRoute("/_authed/dashboard")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: typeof search.token === "string" ? search.token : undefined,
    }
  },
})

// THIS IS THE DEFAULT ROUTE FOR ALL USERS
function RouteComponent() {
  const { isAuthenticated, isLoading } = useAuth()
  const { isIndividual, isProfessional } = useUserType()
  const navigate = useNavigate()
  const { token } = Route.useSearch()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // If there's an invitation token, redirect to invitation page
      if (token) {
        navigate({
          to: "/invitation/$token",
          params: { token },
          replace: true,
        })
        return
      }

      // Normal dashboard routing
      if (isIndividual) {
        navigate({
          to: "/personal/goals",
          replace: true,
        })
      }
      if (isProfessional) {
        navigate({
          to: "/professional/clients",
          replace: true,
        })
      }
    }
  }, [isAuthenticated, isLoading, isIndividual, isProfessional, navigate, token])

  if (isLoading) {
    return <PageLoader />
  }

  if (!isAuthenticated || !isIndividual || !isProfessional) {
    return null // Will redirect in useEffect
  }
  return null
}
